export default "__VITE_ASSET__JnE3Vlij__"